export default __webpack_public_path__ + "static/media/monkey.a2a52798.ogg";